<div class="row">
	<div class="col-12 text-center section-title">
		<h1 class="pt-5">Life Insurance Just Got Easier.</h1>
		<h2>Brokerage eApp</h2>
	</div>
</div>
<div class="row justify-content-center">
	<div class="col-12 col-md-8">
		<hr>

		<!-- Payment form -->
		<form class="jh-form" [formGroup]="applyForm" (ngSubmit)="onSubmit(applyForm)" [ngClass]="{'processing': processing}" nonvalidate>
			<!-- overlay -->
			<div class="overlay" *ngIf="processing"></div>

			<div class="form-group block">
				<span>Email address to receive decision details</span>
				<label for="agentEmail" class="visually-hidden">Agent Email</label>
				<input id="agentEmail" class="form-control" type="email" placeholder="email@address.com" formControlName="agentEmail">
			</div>

			<div class="form-group block">
				<label>Simulate Decision</label>
				<div class="select-wrapper">
					<label for="decision" class="visually-hidden">Decision</label>
					<select id="decision" class="form-control" formControlName="decision">
						<option [ngValue]="null" label="Select one" selected="selected"></option>
						<option *ngFor="let opt of decisionOptions" [value]="opt.value">
							{{ opt.label }}
						</option>
					</select>
				</div>
			</div>

			<div class="form-group block">
				<label>Simulate Persona</label>
				<div class="select-wrapper">
					<label for="persona" class="visually-hidden">Persona</label>
					<select id="persona" class="form-control" formControlName="persona">
						<option [ngValue]="null" label="All Access (default)" selected="selected"></option>
						<option value="Agent" label="Agent"></option>
						<option value="ProposedInsured" label="Proposed Insured"></option>
					</select>
				</div>
			</div>

			<div class="checkbox-wrapper" style="margin-bottom:30px">
				<mat-checkbox formControlName="demoYes">
					<span class="label">Demo Case?</span>
				</mat-checkbox>
			</div>

			<div class="button-wrapper text-center">
				<button class="btn btn-primary" type="submit">Let's get started <i class="fas fa-angle-right"></i></button>
			</div>
		</form>

		<!-- spinner -->
		<div class="spinner-wrapper text-center" [ngClass]="{'show': processing}">
			<mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
		</div><!-- /spinner -->
	</div>
</div>

